export class ApiEntityModel<TKey> {
  id: TKey;
  guid: string;
}

export class ApiOption<TValue> {
  id: TValue;
  name: string;
}



// WEBPACK FOOTER //
// ./src/_foundation/models/base.models.ts